import { useParams } from 'react-router-dom'

import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'
import { useAppSelector } from 'src/Hooks/redux'
import { spotifyTotalPriceSelector } from 'src/Redux/spotifyCampaignMatchingProcess'

interface SpotifyCampaignMatchingResponse {
  minCuratorsCount: number
  maxCuratorsCount: number
  maxPlaylistsCount: number
  totalPrice: number
  totalPlaylistFollowers: number
}

interface SpotifyCampaignMatchingArgs {
  campaignId: number
  budget: number
}

const spotifyCampaignMatchingApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getSpotifyCampaignMatching: builder.query<
      SpotifyCampaignMatchingResponse,
      SpotifyCampaignMatchingArgs
    >({
      query: ({ campaignId, budget }) =>
        `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/${campaignId}/matching-by-budget/${budget}`,
      providesTags: ['SpotifyCampaign'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetSpotifyCampaignMatchingQuery } = spotifyCampaignMatchingApi

interface UseSpotifyCampaignMatchingResult {
  data?: SpotifyCampaignMatchingResponse
  minCuratorsCount: number | null
  maxCuratorsCount: number | null
  maxPlaylistsCount: number | null
  totalPlaylistFollowers: number | null
  isFetching: boolean
  isError: boolean
}

export const useSpotifyCampaignMatching =
  (): UseSpotifyCampaignMatchingResult => {
    const { number: campaignId } = useParams()
    const budget = useAppSelector(spotifyTotalPriceSelector)

    const numericCampaignId = Number(campaignId)
    const numericBudget = Number(budget)

    const skip = !campaignId || !budget || !numericBudget

    const result = useGetSpotifyCampaignMatchingQuery(
      { campaignId: numericCampaignId, budget: numericBudget },
      { skip },
    )

    return {
      data: result.data,
      minCuratorsCount: result.data?.minCuratorsCount ?? null,
      maxCuratorsCount: result.data?.maxCuratorsCount ?? null,
      maxPlaylistsCount: result.data?.maxPlaylistsCount ?? null,
      totalPlaylistFollowers: result.data?.totalPlaylistFollowers ?? null,
      isFetching: result.isFetching,
      isError: result.isError,
    }
  }
